import useSWR from "swr";

import { normalizeCoverageAreaFilters } from "@/components/screens/CoverageArea/coverage-area-filter-helpers";
import { CoverageAreaFilter } from "@/components/screens/CoverageArea/types";
import SWR_KEYS from "@/constants/swr-keys";
import ICoverageArea from "@/interfaces/coverage-area.interface";
import coverageAreaService from "@/services/coverage-area.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export interface Props extends RequestPagination {
  filters: CoverageAreaFilter[];
}

type GetAllSwrParams = [string, number, number, IFilter<ICoverageArea>[]];

export type Return = RequestsBaseReturn<PaginatedResponse<ICoverageArea> | null>;

const useGetCoverageAreas = ({ pageNumber, pageSize, filters }: Props): Return => {
  const normalizedFilter = normalizeCoverageAreaFilters(filters);

  const fetcher = useSWR<PaginatedResponse<ICoverageArea>, Error, GetAllSwrParams>(
    [SWR_KEYS.getCoverageAreas, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      coverageAreaService.filter(_filters, { pageNumber: _pageNumber, pageSize: _pageSize }),
    { revalidateOnFocus: false, shouldRetryOnError: false, errorRetryCount: 0 }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetCoverageAreas;
